const state = function () {
  return {
    loadingData: false,
    list: [],
    rejectionNotes: null,
    classSearchFields: {
      CLASS_ID: null,
      '~CLASS.AFFILIATE_ID': null,
      //'CLASS.INSTRUCTOR_ID': null,
      'CLASS.LK_CLASS_APPROVAL_STATUS_ID': null,
      'CLASS.CLASS_START_DATE': null,
      'CLASS.DATE_CREATED_END': null,
      DATE_CREATED: null
    },
    paginationOptions: {
      rowsNumber: 0,
      rowsPerPage: 10,
      page: 1,
      sortBy: 'DATE_CREATED',
      descending:true
    },
    columnOptions: [
      { field: 'CLASS_ID', name: 'CLASS_ID', label: 'Class', sortable: true, align:'left'},
      { field: 'CLASS_CODE', name: 'CLASS_CODE', label: 'Class Code', sortable: true, align: 'left'},
      { field: 'CLASS_START_DATE', name: 'CLASS_START_DATE', label: 'Class Start Date', sortable: true, type: 'date', align: 'left'},
      { field: 'STATUS', name: 'STATUS', label: 'Status', sortable: true, align: 'left'},
      { field: 'NOTES', name: 'NOTES', label: 'Notes', sortable: true},
      { field: 'USER', name: 'USER', label: 'Submitted By' },
      { field: 'DATE_CREATED', name: 'DATE_CREATED', label: 'Original Submission Date', sortable: true, type:'date', align:'left'},
    ],
  }
}

export default {
  ...state()
}

export const initialState = state()
